import { render, staticRenderFns } from "./DonationSlider.vue?vue&type=template&id=c1880b9c"
import script from "./DonationSlider.vue?vue&type=script&lang=js"
export * from "./DonationSlider.vue?vue&type=script&lang=js"
import style0 from "./DonationSlider.vue?vue&type=style&index=0&id=c1880b9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports